export default "__VITE_ASSET__7c66e3ad__"